export const Occupations = {
  "1": {
    FR: "Sans emploi",
    KEY: "1",
    EN: "Jobless",
  },
  "2": {
    FR: "Commerçant",
    KEY: "2",
    EN: "Trader",
  },
  "3": {
    FR: "Employé",
    KEY: "3",
    EN: "Employee",
  },
  "4": {
    FR: "Fonctionnaire",
    KEY: "4",
    EN: "Civil servant",
  },
  "5": {
    FR: "Artiste/Liberal",
    KEY: "5",
    EN: "Artist/Liberal",
  },
  "6": {
    FR: "Personnel Soignant",
    KEY: "6",
    EN: "Health staff",
  },
  "7": {
    FR: "Personnel Religieux",
    KEY: "7",
    EN: "Religious staff",
  },
  "8": {
    FR: "Policier/Militaire",
    KEY: "8",
    EN: "Police/Military",
  },
  "9": {
    FR: "Politicien/Officiels",
    KEY: "9",
    EN: "Politicians/Officials",
  },
  "10": {
    FR: "Etudiant/Elève",
    KEY: "10",
    EN: "Student/Pupil",
  },
};
